import {
  Home,
  Building,
  FileText,
  DollarSign,
  MessageSquare,
  UserCheck,
  Shield,
} from "lucide-react";
import DashboardLayout from "../../components/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { useAuth } from "../../contexts/AuthContext";

export default function CRM() {
  const { user } = useAuth();

  const sidebarItems = [
    {
      label: "Dashboard",
      path: "/jainboarding-admin/dashboard/hostel-admin",
      icon: <Home className="h-5 w-5" />,
    },
    {
      label: "Hostels",
      path: "/jainboarding-admin/hostels",
      icon: <Building className="h-5 w-5" />,
    },
    {
      label: "Scholarships",
      path: "/jainboarding-admin/scholarships",
      icon: <FileText className="h-5 w-5" />,
    },
    {
      label: "Funding Status",
      path: "/jainboarding-admin/funding",
      icon: <DollarSign className="h-5 w-5" />,
    },
    {
      label: "Reports",
      path: "/jainboarding-admin/reports",
      icon: <FileText className="h-5 w-5" />,
    },
    {
      label: "CMS",
      path: "/jainboarding-admin/cms",
      icon: <MessageSquare className="h-5 w-5" />,
    },
    {
      label: "CRM",
      path: "/jainboarding-admin/crm",
      icon: <UserCheck className="h-5 w-5" />,
    },
    {
      label: "Settings",
      path: "/jainboarding-admin/settings",
      icon: <Shield className="h-5 w-5" />,
    },
  ];

  return (
    <DashboardLayout
      sidebarItems={sidebarItems}
      currentPath="/jainboarding-admin/crm"
      userName={user?.email ?? "Admin"}
      userPhone=""
    >
      <div className="space-y-6">
        <div>
          <h2 className="mb-2 text-3xl font-bold text-foreground">
            Customer Relationship Management
          </h2>
          <p className="text-muted-foreground">Manage customer interactions</p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>CRM Dashboard</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">CRM features coming soon...</p>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
}
